import React from 'react';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';
import { Badge } from 'reactstrap';
import { Link } from 'react-router-dom';
import Header from 'app/components/layout/Header';
import SectionGroup from 'app/components/general/SectionGroup';
import ConnectionGroup from 'app/components/general/ConnectionGroup';
import StatusBadge from 'app/components/general/StatusBadge';
import CopyCaption from 'app/components/general/CopyCaption';
import Button from 'app/components/general/Button';
import history from 'app/routes/history';

import { simpleDateTwo, parseAmount } from 'app/utils/parsers';
import { ITeamMember } from 'app/ducks/teamMembers/types';
import DeleteIcon from 'app/images/icons/delete.svg';
import EditIcon from 'app/images/icons/edit.svg';
import EditTeamMember from 'app/components/teamMembers/EditTeamMember';
import IconModal from 'app/components/general/IconModal';

import ModalConfirm from 'app/components/general/ModalConfirm';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PaymentCollectionsTable from 'app/components/teamMembers/PaymentCollectionsTable';

import * as teamMembersActions from 'app/ducks/teamMembers/actions';
import * as paymentCollectionActions from 'app/ducks/teamPaymentCollections/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';
import * as teamPaymentCollectionsSelectors from 'app/ducks/teamPaymentCollections/selectors';

import CompetitionIcon from 'app/images/icons/organisation.svg';

function selector(state) {
  return {
    teamMembers: teamMembersSelectors.getTeamMembers(state),
    teamPaymentCollections: teamPaymentCollectionsSelectors.getTeamPaymentCollections(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamMembersActions,
  paymentCollectionActions,
);

interface ITeamMemberDetailProps {
  appReady: boolean;
  actions: any;
  match: any;
  teamMembers: any;
  teamPaymentCollections: any;
  backendErrors: any;
  errors: any;
  isLoading: boolean;
}

interface ITeamMemberDetailState {
  editModalOpen: boolean;
  deleteModalOpen: boolean;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class TeamMemberDetail extends React.Component<ITeamMemberDetailProps, ITeamMemberDetailState> {
  static defaultProps: ITeamMemberDetailProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    teamMembers: undefined,
    teamPaymentCollections: undefined,
    backendErrors: undefined,
    isLoading: false,
    errors: undefined,
  };

  state: ITeamMemberDetailState = {
    editModalOpen: false,
    deleteModalOpen: false,
  };

  componentDidMount = (): void => {
    this.props.actions.getTeamMember(this.props.match.params.teamMemberId);
  };

  handleOpenEditModal = (e): void => {
    e.preventDefault();
    this.setState({ editModalOpen: true });
  };

  handleCloseEditModal = (e): void => {
    e.preventDefault();
    this.setState({ editModalOpen: false });
  };

  handleOpenDeleteModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteModalOpen: true });
  };

  handleCloseDeleteModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteModalOpen: false });
  };

  statusBadges = (owingNumber, overdueNumber): React.ReactNode[] => {
    const statuses = [];

    if (owingNumber > 0) {
      statuses.push(
        <StatusBadge
          paymentText="owing"
          numberOfObjects={owingNumber}
        />,
      );
    }
    if (overdueNumber > 0) {
      statuses.push(
        <StatusBadge
          paymentText="overdue"
          numberOfObjects={overdueNumber}
        />,
      );
    }

    return statuses;
  };

  render(): React.ReactNode {
    const teamMember = this.props.teamMembers.currentTeamMember;
    const isLoading = this.props.teamMembers.isLoading && teamMember?.id !== this.props.match.params.teamMemberId;
    const actions = [];
    actions.push(<Button
      className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
      noLoading
      onClick={this.handleOpenEditModal}
    >
      Edit team member
    </Button>);
    actions.push(<Button
      className="btn-standard btn-small btn-2 margin-right-10 margin-bottom-10"
      noLoading
      onClick={this.handleOpenDeleteModal}
    >
      Delete team member
    </Button>);
    return (
      <div>
        <IconModal
          title="Edit Team Member"
          icon={EditIcon}
          handleCancel={this.handleCloseEditModal}
          isOpen={this.state.editModalOpen}
        >
          <EditTeamMember {...this.props} teamId={teamMember.team?.id} afterSubmit={this.handleCloseEditModal} />
        </IconModal>
        <ModalConfirm
          title="Delete Team Member"
          icon={DeleteIcon}
          description="Are you sure you want to delete this team member?"
          buttonText="Delete"
          isOpen={this.state.deleteModalOpen}
          isLoading={this.props.isLoading}
          handleSubmit={(e) => this.props.actions.deleteTeamMember({ id: teamMember.id }, () => history.push('/team-members'))}
          handleCancel={this.handleCloseDeleteModal}
        />
        <div className="row">
          <div className="col">
            <Header
              title={teamMember?.fullName}
              isLoading={isLoading}
              badge={
                this.statusBadges(teamMember?.pendingPaymentCollectionsTotalCount, teamMember?.overduePaymentCollectionsTotalCount)
              }
              descriptors={
                [
                  {
                    icon: <Isvg src={CompetitionIcon} />,
                    descriptor: teamMember?.competitionName,
                  },
                ]
              }
              metadata={[
                {
                  title: 'Since',
                  value: teamMember?.createdAt !== undefined ? simpleDateTwo(teamMember?.createdAt) : '',
                },
                // {
                //   title: 'Teams',
                //   value: teamMember?.numberOfTeams?.toString(),
                // },
                {
                  title: 'Paid-to-date',
                  value: parseAmount(teamMember?.paidPaymentCollectionsTotalAmount),
                },
                {
                  title: 'Owing',
                  value: parseAmount(teamMember?.pendingPaymentCollectionsTotalAmount),
                },
              ]}
            />
          </div>
        </div>
        <div className="main-content">
          {actions.length > 0 && (
            <div className="row with-margin-bottom-extra">
              <div className="col col-12">
                <SectionGroup title="Actions" isLoading={isLoading}>
                  {/* <div className="btn-flex-group">
                        <div className="btn-flex-container"> */}
                  {_.map(actions, (a) => a)}
                  {/* </div>
                      </div> */}
                </SectionGroup>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col col-12 col-lg-8 col-xlg-6">
              <SectionGroup title="Details" isLoading={isLoading}>
                <div className="row">
                  <div className="col col-4 text-grey">
                    Full Name
                  </div>
                  <div className="col">
                    {teamMember?.fullName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Email
                  </div>
                  <div className="col">
                    {teamMember?.email}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Mobile
                  </div>
                  <div className="col">
                    {teamMember?.mobile}
                  </div>
                </div>
                {!_.isEmpty(teamMember?.team) && (
                  <div className="row with-margin-top-10">
                    <div className="col col-4 text-grey">
                      Team
                    </div>
                    <div className="col">
                      <Link to={`/teams/detail/${teamMember?.team?.id}`}>{teamMember?.team?.name}</Link>
                    </div>
                  </div>
                )}
                {/* <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Unique Key
                  </div>
                  <div className="col">
                    {!_.isEmpty(teamMember?.uniqueCode) && <CopyCaption text={teamMember?.uniqueCode} />}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Competition/s
                  </div>
                  <div className="col">
                    {teamMember?.competitionName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Section/s
                  </div>
                  <div className="col">
                    {teamMember?.sectionName}
                  </div>
                </div>
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Season/s
                  </div>
                  <div className="col">
                    {teamMember?.seasonName}
                  </div>
                </div> */}
                <div className="row with-margin-top-10">
                  <div className="col col-4 text-grey">
                    Internal Identifier
                  </div>
                  <div className="col">
                    <CopyCaption text={teamMember?.id} />
                  </div>
                </div>
              </SectionGroup>
            </div>
          </div>
          <div className="row with-margin-top-extra">
            <div className="col">
              <PaymentCollectionsTable
                {...this.props.teamPaymentCollections}
                appReady={this.props.appReady}
                actions={this.props.actions}
                headerTitle="Payment Requests"
                saveFilters={false}
                hideButtons
                isLoading={this.props.teamPaymentCollections.isLoading}
                persistentFilterConfig={{
                  teamMemberId: this.props.match.params.teamMemberId,
                }}
                selectPaymentCollection={this.props.actions.selectPaymentCollection}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
